<template>
  <div>
    <div v-if="navegando" class="barra-navegacion">
      <v-progress-linear indeterminate height="4" color="primary" />
    </div>

    <v-app-bar app color="#f6f6f6" elevate-on-scroll elevation="4">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <v-spacer></v-spacer>
      <WhatsAppVincular v-if="rutaAcceso" />
      <NotificationBadgeDashboard />
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <span
            v-bind="attrs"
            v-on="on"
            style="cursor: pointer"
            class="mx-5 mr-10"
          >
            <v-chip link class="user-chip" color="grey lighten-5">
              <v-badge dot bottom offset-y="10" offset-x="10" color="success">
                <v-avatar size="35">
                  <v-img src="@/assets/users.png" />
                </v-avatar>
              </v-badge>
              <span class="user-name ml-2">{{
                datosUser.nombre_completo
              }}</span>
              <v-icon small class="ml-1">mdi-chevron-down</v-icon>
            </v-chip>
          </span>
        </template>
        <v-list width="300" class="user-menu py-0">
          <v-list-item class="user-header">
            <v-list-item-avatar size="48">
              <v-img src="@/assets/users.png" />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="title font-weight-medium">
                {{ datosUser.nombre_completo }}
              </v-list-item-title>
              <v-list-item-subtitle class="caption">
                <v-chip x-small color="success" class="px-2" text-color="white">
                  <v-icon left x-small>mdi-circle-medium</v-icon>
                  En Línea
                </v-chip>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item
            v-for="{ icon, title } in menus"
            :key="icon"
            v-if="title !== 'Salir'"
            link
            class="menu-option"
            @click="handleMenuItemClick(title)"
          >
            <v-list-item-icon>
              <v-icon color="grey darken-1">{{ icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="subtitle-2">{{
                title
              }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon small color="grey lighten-1">mdi-chevron-right</v-icon>
            </v-list-item-action>
          </v-list-item>

          <!-- <v-divider class="my-2"></v-divider> -->

          <!-- Funcionalidad mudada al modulo ARCA -->
           
          <!--
          <v-list-item class="online-status-item px-4 py-2">
            <v-list-item-icon class="my-auto">
              <v-icon :color="switch1 ? 'success' : 'grey'">
                {{ switch1 ? "mdi-wifi" : "mdi-wifi-off" }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-subtitle class="caption grey--text mb-1">
                Modo de Conexión
              </v-list-item-subtitle>
              <v-switch
                v-model="switch1"
                flat
                dense
                hide-details
                class="mt-0"
                :color="switch1 ? 'success' : 'grey'"
              >
                <template v-slot:label>
                  <span
                    :class="
                      switch1
                        ? 'success--text font-weight-medium'
                        : 'grey--text'
                    "
                  >
                    {{ switch1 ? "Online" : "Offline" }}
                  </span>
                </template>
              </v-switch>
            </v-list-item-content>
          </v-list-item>
          -->

          <v-divider></v-divider>

          <v-list-item class="printer-status-item px-4 py-2">
            <v-list-item-icon class="my-auto">
              <v-icon :color="switch1 ? 'success' : 'grey'">
                {{ switch1 ? "mdi-printer-check" : "mdi-printer-off" }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-subtitle class="caption grey--text mb-1">
                Estado de Impresora
              </v-list-item-subtitle>
              <v-switch
                v-model="switch2"
                flat
                dense
                hide-details
                class="mt-0"
                :color="switch2 ? 'success' : 'grey'"
                :label="switch2 ? 'Encendida' : 'Apagada'"
              >
                <template v-slot:label>
                  <span
                    :class="
                      switch2
                        ? 'success--text font-weight-medium'
                        : 'grey--text'
                    "
                  >
                    {{ switch2 ? "Encendida" : "Apagada" }}
                  </span>
                </template>
              </v-switch>
            </v-list-item-content>
          </v-list-item>

          <v-divider class="my-2"></v-divider>

          <v-list-item link class="logout-option px-4 py-2" @click="logout">
            <v-list-item-icon class="my-auto">
              <v-icon color="error">mdi-logout-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                class="subtitle-2 error--text font-weight-medium"
              >
                Cerrar Sesión
              </v-list-item-title>
              <v-list-item-subtitle class="caption">
                Salir del sistema
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon small color="error">mdi-chevron-right</v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <!-- SIDEBAR -->
    <v-navigation-drawer
      v-model="drawer"
      app
      dark
      class="navigation-drawer"
      color="primary"
    >
      <div class="">
        <v-img
          :src="srcLogo"
          height="100%"
          width="100%"
          class="header-logo"
        ></v-img>
      </div>

      <v-divider></v-divider>

      <v-list
        nav
        dense
        class="menu-list modern-menu"
        :class="{ 'menu-list--bloqueada': navegando }"
      >
        <!-- Iteramos sobre los elementos del menú -->
        <template v-for="(item, index) in links">
          <!-- Si el elemento tiene submenús -->
          <v-list-group
            v-if="item.submenus && item.submenus.length > 0"
            :key="'grupo-' + index"
            :value="valorExpansionGrupo(index)"
            :class="{ 'modulo-activo': grupoActivoIndex === index }"
            no-action
            color="white"
            active-class="grupo-activo"
            class="menu-group"
          >
            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon>{{ item.icono }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.menu }}</v-list-item-title>
              </v-list-item-content>
            </template>

            <!-- Submenús -->
            <v-list-item
              v-for="(submenu, subIndex) in item.submenus"
              :key="'submenu-' + index + '-' + subIndex"
              link
              @click="navegarDesdeMenu(submenu.ruta)"
              class="menu-item submenu-item pl-4"
              :class="{ 'v-list-item--active': esItemActivo(index, subIndex) }"
            >
              <v-list-item-icon>
                <v-icon>{{ submenu.icono }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ submenu.menu }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <!-- Si el elemento no tiene submenús -->
          <v-list-item
            v-else
            :key="'item-' + index"
            link
            @click="navegarDesdeMenu(item.ruta)"
            class="menu-item main-menu-item"
            :class="{ 'v-list-item--active': esItemActivo(index, null) }"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icono }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.menu }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>

      <!-- Publicidad: tarjeta silenciosa al pie del menú (nada si no hay campaña) -->
      <template v-slot:append>
        <TarjetaMenu />
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import NotificationBadgeDashboard from "./NotificationBadgeDashboard.vue";
import WhatsAppVincular from "./WhatsAppVincular.vue";
import TarjetaMenu from "../publicidad/TarjetaMenu.vue";

// Quita la barra final para poder comparar rutas por segmento completo
// ("/compras" matchea "/compras/ordenes" pero no "/compras-usadas").
// Raíz "/" queda como "" para que un módulo sin ruta no matchee todo.
function normalizarRuta(ruta) {
  return (ruta || "/").replace(/\/+$/, "");
}

export default {
  name: "Header",
  created() {
    this.createMenu();
    localStorage.setItem("xml_stat", true);
    localStorage.setItem("estado_impresora", true);
    let token = JSON.parse(localStorage.getItem("token"));
    this.rutaAcceso = token.rutas.whatsapp == 1 ? true : false;
  },
  components: {
    NotificationBadgeDashboard,
    WhatsAppVincular,
    TarjetaMenu,
  },
  data() {
    return {
      switch1: true,
      switch2: true,
      navegando: false,
      drawer: null,
      links: [],
      group: null,
      modulos: [],
      // Ruta del ítem que el usuario tocó en el sidebar (memoria de sesión,
      // nunca se persiste: al refrescar no hay pin y manda la ruta actual).
      rutaPineada: null,
      menus: [
        { title: "Perfil", icon: "mdi-account" },
        { title: "Novedades", icon: "mdi-bullhorn-outline" },
        { title: "Salir", icon: "mdi-logout" },
      ],
    };
  },

  computed: {
    ...mapGetters({
      DatosUsuario: "datosUser",
    }),

    srcLogo() {
      if (this.$empresaConfig?.logos?.logo_menu) {
        return this.$empresaConfig.logos.logo_menu;
      }

      try {
        return require(`@/assets/logo_${process.env.VUE_APP_EMPRESA}.png`);
      } catch (e) {
        return "";
      }
    },

    datosUser: {
      get() {
        return this.DatosUsuario;
      },
      set(newName) {
        return newName;
      },
    },

    // Todos los elementos del menú (raíces de grupo, hojas y submenús) como
    // candidatos a resaltarse. La raíz de un grupo compite con sus propios
    // submenús: gana el de la ruta más larga, los empates se los lleva el
    // primero (#421: un solo módulo activo aunque las rutas se superpongan).
    elementos() {
      const candidatos = [];

      this.links.forEach((link, indiceLink) => {
        const submenus = link.submenus || [];

        if (submenus.length > 0) {
          candidatos.push({
            indiceLink,
            indiceSub: -1,
            ruta: link.ruta,
            esGrupo: true,
          });
          submenus.forEach((submenu, indiceSub) => {
            candidatos.push({
              indiceLink,
              indiceSub,
              ruta: submenu.ruta,
              esGrupo: false,
            });
          });
        } else {
          candidatos.push({
            indiceLink,
            indiceSub: -1,
            ruta: link.ruta,
            esGrupo: false,
          });
        }
      });

      return candidatos;
    },

    // Ítem que el usuario tocó en el sidebar, si la ruta actual sigue
    // dentro de ese módulo. Tiene prioridad sobre el matching por ruta.
    elementoPineado() {
      if (!this.rutaPineada || !this.esRutaActual(this.rutaPineada)) return null;

      const normalizada = normalizarRuta(this.rutaPineada);
      return (
        this.elementos.find((elemento) => normalizarRuta(elemento.ruta) === normalizada) || null
      );
    },

    // Ganador del resaltado: el pin si sigue vigente, si no el candidato
    // cuya ruta más larga contenga a la ruta actual.
    elementoGanador() {
      if (this.elementoPineado) return this.elementoPineado;

      const coincidencias = this.elementos.filter((elemento) =>
        this.esRutaActual(elemento.ruta)
      );

      return coincidencias.reduce((mejor, actual) => {
        if (!mejor) return actual;
        return normalizarRuta(actual.ruta).length > normalizarRuta(mejor.ruta).length
          ? actual
          : mejor;
      }, null);
    },

    // Resaltado exclusivo: qué grupo recibe .modulo-activo y qué ítem recibe
    // .v-list-item--active. -1 = ninguno.
    resaltado() {
      const ganador = this.elementoGanador;

      if (!ganador) return { modulo: -1, itemLink: -1, itemSub: -1 };

      if (ganador.esGrupo) {
        // El grupo gana la ruta pero la sub-opción puede coincidir igual
        // (p. ej. ruta exacta de un hijo): se resalta la mejor que matchee.
        const subActivo = this.mejorSubmenuActivo(ganador.indiceLink);
        return {
          modulo: ganador.indiceLink,
          itemLink: subActivo === -1 ? -1 : ganador.indiceLink,
          itemSub: subActivo,
        };
      }

      if (ganador.indiceSub >= 0) {
        // Submenú: su módulo (el grupo que lo contiene) también se resalta.
        return {
          modulo: ganador.indiceLink,
          itemLink: ganador.indiceLink,
          itemSub: ganador.indiceSub,
        };
      }

      // Hoja: solo el ítem, sin módulo (#421: la hoja y su grupo no se
      // resaltan a la vez aunque sus rutas se superpongan).
      return { modulo: -1, itemLink: ganador.indiceLink, itemSub: -1 };
    },

    // Índice del grupo cuyo menú contiene la ruta actual; -1 si ninguno.
    grupoActivoIndex() {
      return this.resaltado.modulo;
    },
  },

  methods: {
    handleMenuItemClick(title) {
      switch (title) {
        case "Perfil":
          this.$router.push("/perfil");
          break;
        case "Novedades":
          this.$router.push("/novedades");
          break;
        case "Salir":
          this.logout();
          break;
        default:
          // Acción por defecto si no coincide con ninguna opción
          break;
      }
    },
    logout() {
      this.$store.dispatch("logout");
    },
    createMenu() {
      // Guardamos los módulos originales
      this.modulos = this.datosUser.modulos;

      // Procesamos los módulos para el menú
      if (this.modulos && this.modulos.length > 0) {
        this.links = this.modulos.map((modulo) => {
          return {
            icono: modulo.icono,
            menu: modulo.nombre,
            ruta: modulo.ruta || "/",
            id_modulo: modulo.id_modulo,
            submenus: modulo.menus || [],
          };
        });
      } else {
        // Si no hay módulos, usamos el menú anterior (para compatibilidad)
        this.links = this.datosUser.menu || [];
      }
    },

    esRutaActual(rutaMenu) {
      const rutaActual = normalizarRuta(this.$route.path);
      const rutaDelMenu = normalizarRuta(rutaMenu);

      if (!rutaDelMenu) return rutaActual === "";
      return rutaActual === rutaDelMenu || rutaActual.startsWith(`${rutaDelMenu}/`);
    },

    // Navegación desde el sidebar: deja el ítem "pineado" (memoria de la
    // sesión) para que la selección no salte mientras el usuario siga
    // navegando dentro del módulo. El pin se borra al salir de la ruta.
    // Mientras el push está pendiente se muestra la barra superior y se
    // bloquean los clicks nuevos, hasta que la pantalla destino está
    // dibujada (#439 + #421 fusionados en un único método).
    navegarDesdeMenu(ruta) {
      if (this.navegando) return;
      this.rutaPineada = ruta;
      if (this.$route.path === ruta) return;
      this.navegando = true;
      try {
        this.$router
          .push(ruta)
          .catch(() => {})
          .then(() => {
            this.$nextTick(() => {
              this.navegando = false;
            });
          });
      } catch {
        this.navegando = false;
      }
    },

    // ¿Este ítem del menú es el que hay que resaltar? indiceSub null = hoja.
    esItemActivo(indiceLink, indiceSub) {
      const { itemLink, itemSub } = this.resaltado;
      const subEsperado = indiceSub === null ? -1 : indiceSub;

      return itemLink === indiceLink && itemSub === subEsperado;
    },

    // Mejor submenú de un grupo para la ruta actual (el de la ruta más
    // larga); -1 si ninguno coincide.
    mejorSubmenuActivo(indiceLink) {
      const submenus = (this.links[indiceLink] && this.links[indiceLink].submenus) || [];

      return submenus.reduce((mejor, submenu, indiceSub) => {
        if (!this.esRutaActual(submenu.ruta)) return mejor;
        if (mejor === -1) return indiceSub;

        const actualMejor = normalizarRuta(submenus[mejor].ruta).length;
        return normalizarRuta(submenu.ruta).length > actualMejor ? indiceSub : mejor;
      }, -1);
    },

    valorExpansionGrupo(index) {
      // Pasamos la ruta (no true) como value: al cambiar de pantalla el prop
      // cambia y el grupo vuelve a abrirse aunque el usuario lo haya cerrado.
      // El cierre/acordeón lo sigue manejando VList, igual que siempre.
      return this.grupoActivoIndex === index ? this.$route.path : false;
    },
  },

  watch: {
    "$route.path"() {
      // El pin solo vive mientras la ruta siga dentro del módulo pineado:
      // al salir, manda el matching por ruta (#421).
      if (this.rutaPineada && !this.esRutaActual(this.rutaPineada)) {
        this.rutaPineada = null;
      }
    },
    switch1(val) {
      localStorage.setItem("xml_stat", val);
    },
    switch2(val) {
      localStorage.setItem("estado_impresora", val);
    },
  },
};
</script>

<style>
.barra-navegacion {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  pointer-events: none;
}

.navigation-drawer {
  border-radius: 0 16px 16px 0;
  transition: all 0.3s ease;
}

.v-navigation-drawer__content {
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.v-navigation-drawer__content::-webkit-scrollbar {
  display: none;
}

.menu-item {
  border-radius: 8px;
  margin: 4px 8px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.menu-item:hover {
  transform: translateX(4px);
  background: rgba(255, 255, 255, 0.08) !important;
}

.menu-list--bloqueada .menu-item {
  pointer-events: none;
}

.menu-item.v-list-item--active {
  background: rgba(255, 255, 255, 0.12) !important;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
}

/* Estilo moderno para el menú completo */
.modern-menu {
  padding: 8px;
}

/* Estilos para los grupos de menú */
.menu-group {
  margin-bottom: 4px;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
}

/* Grupo expandido: marca "abierto" (tinte + chevron rotado), NO "estás acá".
   El look activo es exclusivo de .modulo-activo: si el estado expandido
   pintara igual, un grupo abierto y el módulo de la ruta actual se verían
   resaltados a la vez (#421). */
.v-list-group--active {
  background: rgba(0, 0, 0, 0.15) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.v-list-group--active > .v-list-group__header {
  border-radius: 8px 8px 0 0;
  margin: 0;
  padding: 0 8px;
  height: 48px;
}

/* Estilo para el encabezado del grupo cuando no está expandido */
.v-list-group__header {
  border-radius: 8px;
  margin: 0 4px;
  transition: all 0.3s ease;
}

.v-list-group__header:hover {
  background: rgba(255, 255, 255, 0.1) !important;
}

/* Módulo que contiene la ruta actual: resaltado aunque el grupo esté cerrado */
.modulo-activo > .v-list-group__header {
  background: rgba(255, 255, 255, 0.15) !important;
  border-left: 3px solid rgba(255, 255, 255, 0.7);
}

.modulo-activo > .v-list-group__header .v-list-item__title {
  color: white !important;
  font-weight: 500;
  letter-spacing: 0.3px;
}

.modulo-activo > .v-list-group__header .v-icon {
  color: white !important;
}

/* Estilo para el icono de expansión */
.v-list-group__header__append-icon .v-icon {
  color: rgba(255, 255, 255, 0.8) !important;
  font-size: 18px;
  transition: transform 0.3s ease;
}

.v-list-group--active .v-list-group__header__append-icon .v-icon {
  transform: rotate(-180deg);
}

/* Estilo para los elementos de submenú */
.submenu-item {
  border-left: 3px solid rgba(255, 255, 255, 0.3);
  margin: 4px 8px;
  border-radius: 6px;
  height: 40px;
  transition: all 0.2s ease;
}

.submenu-item:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  border-left: 3px solid rgba(255, 255, 255, 0.7);
}

.submenu-item.v-list-item--active {
  background: rgba(255, 255, 255, 0.15) !important;
  border-left: 3px solid white;
}

/* Estilo para los elementos principales del menú */
.main-menu-item {
  border-radius: 8px;
  margin: 4px;
  height: 44px;
  transition: all 0.2s ease;
}

.main-menu-item:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  transform: translateX(2px);
}

.main-menu-item.v-list-item--active {
  background: rgba(255, 255, 255, 0.15) !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  border-left: 3px solid white;
}

.menu-item.v-list-item--active .v-list-item__title {
  color: white !important;
  font-weight: 500;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.menu-item.v-list-item--active .v-icon {
  color: white !important;
}

.menu-item.v-list-item--active::before {
  opacity: 0 !important;
}

.menu-item.v-list-item--active:hover {
  transform: translateX(4px);
  background: rgba(255, 255, 255, 0.15) !important;
}

.drawer-header {
  border-radius: 0 16px 0 0;
  padding: 16px;
  background: rgba(0, 0, 0, 0.1);
}

.logo-container {
  transition: all 0.3s ease;
  border-radius: 12px;
  overflow: hidden;
  padding: 8px;
  background: rgba(255, 255, 255, 0.03);
}

.logo-container:hover {
  transform: translateY(-1px);
  background: rgba(255, 255, 255, 0.05);
}

.v-list {
  padding: 8px;
}

.v-list-item {
  margin-bottom: 4px;
}

.v-list-item__icon {
  margin-right: 16px;
  transition: transform 0.3s ease;
}

.user-chip {
  height: 42px !important;
  padding: 0 12px !important;
  transition: all 0.2s ease;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
}

.user-chip:hover {
  background: #f8f9fa !important;
  border-color: rgba(0, 0, 0, 0.12) !important;
}

.user-name {
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
  margin-right: 4px;
}

.user-menu {
  border-radius: 8px !important;
  overflow: hidden;
}

.user-header {
  background: linear-gradient(
    to right,
    rgba(var(--v-primary-base), 0.05),
    transparent
  );
  padding: 16px !important;
}

.menu-option {
  min-height: 48px !important;
  margin: 4px 8px !important;
  border-radius: 6px !important;
  transition: all 0.2s ease;
}

.menu-option:hover {
  background: rgba(var(--v-primary-base), 0.05) !important;
}

.menu-option .v-list-item__icon {
  margin: 12px 16px 12px 8px !important;
}

.menu-option .v-list-item__action {
  margin: 0 !important;
}

@media (max-width: 600px) {
  .user-chip {
    margin-left: 8px !important;
    margin-right: 8px !important;
  }
}

.printer-status-item {
  background: rgba(var(--v-primary-base), 0.02) !important;
  border-radius: 8px !important;
  margin: 4px 8px !important;
  transition: all 0.2s ease;
}

.printer-status-item:hover {
  background: rgba(var(--v-primary-base), 0.05) !important;
}

.printer-status-item .v-list-item__icon {
  margin-right: 16px !important;
}

.online-status-item {
  background: rgba(var(--v-primary-base), 0.02) !important;
  border-radius: 8px !important;
  margin: 4px 8px !important;
  transition: all 0.2s ease;
}

.online-status-item:hover {
  background: rgba(var(--v-primary-base), 0.05) !important;
}

.online-status-item .v-list-item__icon {
  margin-right: 16px !important;
}

.logout-option {
  background: linear-gradient(
    to right,
    rgba(244, 67, 54, 0.04),
    transparent
  ) !important;
  border-radius: 8px !important;
  margin: 4px 8px !important;
  border-left: 3px solid transparent !important;
  transition: all 0.2s ease;
}

.logout-option:hover {
  background: linear-gradient(
    to right,
    rgba(244, 67, 54, 0.08),
    transparent
  ) !important;
  border-left: 3px solid #f44336 !important;
  transform: translateX(2px);
}

.logout-option .v-list-item__icon {
  margin-right: 16px !important;
}

.logout-option .v-icon {
  transition: transform 0.2s ease;
}

.logout-option:hover .v-icon {
  transform: scale(1.1);
}

.printer-status-item .v-list-item__icon {
  margin-right: 16px !important;
}
</style>
